export const PAYMENT_ROUTES = {
  LANDING: "/payment/landing",
  VERIFY_PAYMENT_STATUS: "/payment/verify-status",
  PAYMENT_STATUS: "/payment/status"
};
